const uniqueByKey = <T>(arr: T[], key: keyof T) => {
  const uniqueKeys = new Set();
  return arr.filter((el) => {
    const duplicate = uniqueKeys.has(el[key]);
    uniqueKeys.add(el[key]);
    return !duplicate;
  });
};

export default uniqueByKey;
